<!--

============================================================================================================
||    FlowName page                                                                                       ||
============================================================================================================

|   Description
------------------------------------------------------------------------------------------------------------
  First page in flow wizard. User is prompted to give a name to the flow.

|   Props
------------------------------------------------------------------------------------------------------------
  - value       : Object    : Object with valid and data parameters. Valid is a boolean and data is an object with flowName property.

|   Events - page should not emit events
------------------------------------------------------------------------------------------------------------
  - input       : Object    : Emits object with valid and data parameters. Valid is a boolean and data is an object with flowName property.
  - next        : void      : Emits next event to parent component to signal that the next step should be shown.

-->

<template>
  <div
    class="flow-name-step">
    <h2>Give this AI flow a name</h2>
    <p>Assign a name that will describe your flow.</p>
    <ValidationObserver
      ref="nameObserver" >
      <ValidationProvider
        v-slot="{ errors }"
        name="Name"
        rules="required">
        <b-input
          ref="flowNameInputRef"
          v-model="flowName"
          autocomplete="off"
          class="sb2-bordered sb2-hoverable sb2-focusable"
          placeholder="Assign AI support assistant"
          @keydown="catchEnter" />
        <div
          v-if="errors[0]"
          class="error flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'FlowNameStep',
  components: {
    SBIcon,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      flowName: '',
      SBColors,
      SBIconList,
    };
  },
  watch: {
    flowName: {
      handler() {
        this.emitData();
      },
      immediate: true,
    },
  },
  mounted() {
    this.emitData(true);
  },
  methods: {
    catchEnter(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.$emit('next');
      }
    },
    focus() {
      this.$refs.flowNameInputRef.focus();
    },
    emitData(reset = false) {
      if (!this.$refs.nameObserver) return;
      this.$refs.nameObserver.validate()
        .then((valid) => {
          this.$emit('input', {
            valid,
            name: 'flowName',
            data: {
              flowName: this.flowName,
            },
          });
        })
        .finally(() => {
          if (reset && this.$refs.nameObserver) this.$refs.nameObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-name-step {
  h2, p {
    text-align: center;
  }

  h2 {
    font-size: 18px;
    font-weight: bold;
    color: $blackPrimary;
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackUltralight;
    margin-bottom: 33px;
  }

  input {
    height: 54px;
    padding: 20px 15px 18px;
    border-radius: 10px !important;
  }

  .error {
    font-size: 14px;
    color: $redPrimary;
    margin: 7px 0;
  }
}
</style>
